import { MEETINGS_BACK_URL } from "@/config";
import axios from "./axios.callcenter";
import { TLiveSession } from "@/models/call.center.model";
import { CUSTOM_EVENT_SESSION_ENDED, CUSTOM_EVENT_USER_JOINED } from "@icebergeradmin/common";
import { getTimestamp } from "@/utils/dates";
const HOST_ROLE_ID = 1;

export const getLiveSessions = async (callCenterId?: number): Promise<TLiveSession[]> => {
  const params = callCenterId !== undefined ? { callCenterId } : {};
  const response = await axios.get("/sessions", { params });
  return response.data.rooms;
};

export const getHostToken = async (sessionName: string): Promise<string> => {
  const response = await axios.post("/token", {
    sessionName,
    roleId: HOST_ROLE_ID,
  });
  return response.data.token;
};

export const notifySessionEnded = async ({ sessionId, sessionName }: { sessionId: string; sessionName: string }) => {
  await axios.post("/webhooks", {
    event: CUSTOM_EVENT_SESSION_ENDED,
    payload: {
      object: {
        session_id: sessionId,
        session_name: sessionName,
      },
    },
  });
};

// Usa navigator.sendBeacon para enviar datos al descargar la página (refresco, cierre, navegación).
// Debe usarse la URL absoluta del backend; con ruta relativa la petición iría al origen del frontend.
export const markSessionAsEnded = ({ sessionId, sessionName }: { sessionId: string; sessionName: string }) => {
  const data = {
    event: CUSTOM_EVENT_SESSION_ENDED,
    payload: {
      object: {
        session_id: sessionId,
        session_name: sessionName,
      },
    },
  };

  const url = `${MEETINGS_BACK_URL}/webhooks`;
  const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
  navigator.sendBeacon(url, blob);
};

export const notifyHostHasJoined = async ({
  sessionId,
  sessionName,
  email,
  name,
}: {
  sessionId: string;
  sessionName: string;
  email: string;
  name: string;
}) => {
  await axios.post("/webhooks", {
    event: CUSTOM_EVENT_USER_JOINED,
    event_ts: getTimestamp(),
    payload: {
      object: {
        session_id: sessionId,
        session_name: sessionName,
        user: {
          email,
          name,
          role: HOST_ROLE_ID,
        },
      },
    },
  });
};
